import { _get, _post, _put } from "../../../../apiClient";
import moment from 'moment';
import { _showToast } from "../../../../toastHelper";
import config from "../../../../config";
import { deleteImages, uploadImage } from "../../../Services/ImageService";

let invitationJson;
let deletedKeys = [];
let imageCount = 0;
let videoCount = 0;

export default async function Save(sections, themeId, eventId, eventCode, deletedImages) {
    invitationJson = {};
    deletedKeys = [...deletedImages]
    invitationJson.version = "1.0";
    invitationJson.studioId = "";
    imageCount = 0;
    videoCount = 0;

    if (sections && sections.length > 0) {
        let isValid = true;
        sections.forEach(section => {
            if (!section.isValid)
                isValid = false;
        });

        if (isValid) {
            if (!eventCode || (eventCode && eventCode == ""))
                eventCode = await getEventCode();

            if (eventCode && eventCode != "") {
                if (await checkImageAndVideoStatus(sections, eventCode)) {

                    for (const section of sections) {
                        if (section.sectionname == "demo") {
                            if (!await processingDemoDetails(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "categories") {
                            if (!await processingCategories(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "products") {
                            if (!await processingProducts(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                        else if (section.sectionname == "studio") {
                            invitationJson.studioId = section.data;
                        }
                        else if (section.sectionname == "theme") {
                            if (!await processingCustomization(section, eventCode)) {
                                invitationJson = null;
                                break;
                            }
                        }
                    }

                    if (!eventId || (eventId && eventId == 0))
                        return await createDemo(eventCode, themeId);
                    else
                        return await updateDemo(eventId, eventCode);

                }
                else {
                    return {
                        status: "failed",
                        message: ""
                    };
                }
            }

            return {
                status: "failed",
                message: "Unable to process your request"
            };
        }
        return {
            status: "failed",
            message: "Please provide data for all the required fields before saving"
        };
    }
}

const createDemo = async (eventCode, themeId) => {

    if (invitationJson) {
        let postdata = {
            eventCode: eventCode,
            themeId: themeId,
            categoryId: config.demoCategoryId,
            eventTitle: invitationJson.demo.title,
            eventDate: moment(new Date()).format("YYYYMMDD"),
            thumbnail: invitationJson.demo.imageKey,
            expiration: -1,
            studioId: invitationJson.studioId,
            jsonData: JSON.stringify(invitationJson),
            lastEventDate: moment(new Date()).format("YYYYMMDD"),
            imageCount: imageCount,
            videoCount: videoCount
        }

        return await _post("/events", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];
                return {
                    status: "success",
                    eventCode: postdata.eventCode,
                    eventId: response.id,
                    eventUrl: response.url,
                    message: "Demo created successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const updateDemo = async (eventId, eventCode) => {
    if (invitationJson) {
        let postdata = {
            id: eventId,
            eventTitle: invitationJson.demo.title,
            eventDate: moment(new Date()).format("YYYYMMDD"),
            thumbnail: invitationJson.demo.imageKey,
            expiration: -1,
            studioId: invitationJson.studioId,
            jsonData: JSON.stringify(invitationJson),
            lastEventDate: moment(new Date()).format("YYYYMMDD"),
            imageCount: imageCount,
            videoCount: videoCount
        }

        return await _put("/events", postdata)
            .then(async (response) => {
                await deleteImages(deletedKeys);
                deletedKeys = [];
                return {
                    status: "success",
                    eventCode: eventCode,
                    eventId: response.id,
                    eventUrl: response.url,
                    message: "Demo updated successfully"
                };
            })
            .catch((error) => {
                return {
                    status: "failed",
                    message: error
                };
            });
    }
}

const getEventCode = async () => {
    return await _get("/events/code/8")
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return "";
        })
}

const checkImageAndVideoStatus = async (sections, eventCode) => {
    getImageAndVideoCount(sections);
    if (imageCount > 0 || videoCount > 0) {
        return await _get(`/uploads/check-upload-status?eventCode=${eventCode}&imageCount=${imageCount}&videoCount=${videoCount}&studioProfileId=0`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                _showToast(error, "error");
                return false;
            });
    }
    else
        return true;
}

const getImageAndVideoCount = async (sections) => {
    sections.forEach((section) => {
        if (section.data && Array.isArray(section.data)) {
            section.data.forEach((data) => {
                if ((data.imageKey && data.imageKey != "") || (data.imageFile && data.imageFile != null)) {
                    imageCount = imageCount + 1;
                }

                if ((data.youtubeLink && data.youtubeLink != "")) {
                    videoCount = videoCount + 1;
                }
            })
        }
        else {
            if ((section.data.imageKey && section.data.imageKey != "") || (section.data.imageFile && section.data.imageFile != null)) {
                imageCount = imageCount + 1;
            }

            if ((section.data.youtubeLink && section.data.youtubeLink != "")) {
                videoCount = videoCount + 1;
            }
        }
    });
}

const processingDemoDetails = async (section, eventCode) => {
    let path = "";
    if (section.data.imageFile) {
        path = await uploadImage(`demo-data/${eventCode}`, section.data.imageFile, eventCode, "Demo Thumb");
        if (!path || (path && path == ""))
            return false;

        if (section.data.imageKey && section.data.imageKey != "") {
            deletedKeys.push(section.data.imageKey);
        }
        section.data.imageFile = null;
        section.data.image = config.imagesbaseurl + path;
        section.data.imageKey = path;
    }

    invitationJson.demo = {
        title: section.data.title,
        imageKey: section.data.imageKey
    }

    return true;
}

const processingCategories = async (section, eventCode) => {
    invitationJson.categories = [];
    if (section.data) {
        for (const categroy of section.data) {
            invitationJson.categories.push(categroy);
        }
    }
    return true;
}

const processingProducts = async (section, eventCode) => {
    invitationJson.products = [];
    for (const product of section.data) {
        invitationJson.products.push({
            title: product.title,
            youtubeLink: product.youtubeLink,
            ecommerceLink: product.ecommerceLink,
            category: product.category,
            description: product.description,
            isPrimary: product.isPrimary
        });
    }
    return true;
}

const processingCustomization = async (section, eventCode) => {
    invitationJson.sliders = [];
    let datas = [];
    for (const slider of section.data) {
        if (slider.imageFile) {
            let path = await uploadImage(`demo-data/${eventCode}/sliders`, slider.imageFile, eventCode, "Banners");
            if (!path || (path && path == ""))
                return false;

            if (slider.imageKey && slider.imageKey != "") {
                deletedKeys.push(slider.imageKey);
            }
            slider.image = config.imagesbaseurl + path;
            slider.imageFile = null;
            slider.imageKey = path;
        }
        invitationJson.sliders.push({
            imageKey: slider.imageKey
        });
        datas.push(slider);
    }
    section.data = datas;
    return true;
}